export enum EIntegrationProvider {
  UNKNOWN = 'UNKNOWN',
  MAXIMO = 'MAXIMO',
  GOOGLE = 'GOOGLE'
}
export type TIntegrationProvider = keyof typeof EIntegrationProvider;

export enum EScanProvider {
  UNKNOWN = 'UNKNOWN',
  MATTERPORT = 'MATTERPORT',
  NAVVIS = 'NAVVIS'
}

export type TScanProvider = keyof typeof EScanProvider;

export const providerTypeMap: Record<TSupportedProviders, 'INTEGRATION' | 'IOT'> = {
  MAXIMO: 'INTEGRATION',
  GOOGLE: 'INTEGRATION',
  FIBARO: 'IOT',
  SAMSUNG_ST: 'IOT',
  SE: 'IOT',
  WISER_HOME: 'IOT',
  NETX: 'IOT',
  JUNG: 'IOT',
  HOMEY: 'IOT'
};

export enum EIotProvider {
  UNKNOWN = 'UNKNOWN',
  FIBARO = 'FIBARO',
  SAMSUNG_ST = 'SAMSUNG_ST',
  SE = 'SE',
  WISER_HOME = 'WISER_HOME',
  NETX = 'NETX',
  JUNG = 'JUNG',
  HOMEY = 'HOMEY'
}

export type TIotProvider = keyof typeof EIotProvider;
export type TSupportedProviders = Exclude<TIotProvider | TIntegrationProvider, 'UNKNOWN'>;

export const EProviderLabel = {
  ['FIBARO']: $localize`:@@PROVIDERS_FIBARO:Fibaro`,
  ['SE']: $localize`:@@PROVIDERS_KNX:KNX`,
  ['SAMSUNG_ST']: $localize`:@@PROVIDERS_SMART_THINGS:SmartThings`,
  ['WISER_HOME']: $localize`:@@PROVIDERS_WISER:Wiser`,
  ['NETX']: $localize`:@@PROVIDERS_NETX:NETx`,
  ['UNKNOWN']: $localize`:@@NOT_IMPLEMENTED:Not implemented`,
  ['JUNG']: $localize`:@@PROVIDERS_JUNG:JUNG`,
  ['HOMEY']: $localize`:@@PROVIDERS_HOMEY:HOMEY`,
  ['MATTERPORT']: $localize`:@@PROVIDERS_OTHERS:Others`,
  ['NAVVIS']: $localize`:@@PROVIDERS_OTHERS:Others`,
  ['MAXIMO']: $localize`:@@IBM_MAXIMO:IBM Maximo`,
  ['GOOGLE']: $localize`:@@NOT_IMPLEMENTED:Not implemented`
};
